<template>
  <div class="at-eg-task" :class="[classLength, classFloor]">
    <!--
    <div class="at-eg-task-inner">
    {{task.title}}
    </div>
    -->

    <div class= "at-eg-task-inner-ptf" 
      :style='"background-color: " + task.color + "; border= 1px solid " + task.color + ";"' 
      :data-id="task.index" />

    <!-- <div :class= '"at-eg-task-inner-ptf-" + task.colorId' :data-id= 'task.index'  /> -->
  </div>
</template>

<script>

export default {
  props: {
    task: {
      type: Object,
      required: true
    },
    floorIndex: {
      type: Number,
      default: 0
    }
  },
  created() {
  },
  computed: {
    classLength () {
      return 'at-eg-len-' + this.task.duration;
    },
    classFloor () {
      return 'at-eg-floor-' + this.floorIndex
    }
  }
}
</script>

<style>
</style>
